module.exports = __webpack_public_path__ + "945a988047efa5165d0be8038bf38fc8.png";